import { makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import React from 'react'
import { Platform } from 'react-native'

interface Props {
  note?: string
  maxWidth?: number | string
}

export function ShiftNoteView(props: Props) {
  const maxWidthStyle = { maxWidth: props.maxWidth ?? undefined }
  const styles = useStyles(maxWidthStyle)

  if (!props.note) {
    return null
  }

  return (
    <Text style={styles.container} numberOfLines={2}>
      {props.note}
    </Text>
  )
}

export const SHIFT_NOTE_HEIGHT = 35

const useStyles = makeStyles((theme, maxWidthStyle: any) => ({
  container: {
    ...maxWidthStyle,
    paddingHorizontal: 5,
    height: SHIFT_NOTE_HEIGHT,
    fontSize: 13,
    fontFamily: font.bold,
    color: theme.colors.black,
    textAlignVertical: 'center',
    ...Platform.select({
      ios: {
        lineHeight: SHIFT_NOTE_HEIGHT,
      },
      android: {},
      default: {},
    }),
  },
}))
